export default __webpack_public_path__ + "static/media/photo--sm--8.924682a6.jpg";